import { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/services/queryClient';
import { Toaster } from '@/components/ui/toaster';
import { GlobalLoader } from '@/components/ui/GlobalLoader';
import { BootstrapProvider } from './BootstrapProvider';

interface ProvidersProps {
  children: ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <BootstrapProvider>{children}</BootstrapProvider>
      <Toaster />
      <GlobalLoader />
    </QueryClientProvider>
  );
};

